import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SubscriptionFeatureModel, SubscriptionModel } from "./subscription.model";
import { UserService } from "../user/user.service";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { SubscriptionService } from "./subscription.service";
import { CheckoutService } from "./stripe/checkout.service";
import { environment } from "../../../environments/environment";
import { UserModel } from "../user/user.model";
import { GetUserInfo } from "../../shared/utils";
import { DialogsService } from "../../shared/components/dialogs/dialogs.service";
import { STATUS_SUBSCRIPTION } from "./status-subscription.enum";
import { FirstStepsDialogComponent } from "../../shared/components/first-steps-dialog/first-steps-dialog.component";
import { FirstStepsDialogService } from "../../shared/components/first-steps-dialog/first-steps-dialog.service";
import { YearlyUpgradeDialogComponent } from "./yearly-upgrade-dialog/yearly-upgrade-dialog.component";
import { MonthlyDowngradeDialogComponent } from "./monthly-downgrade-dialog/monthly-downgrade-dialog.component";
import { CancelAccountDialogComponent } from "./cancel-account-dialog/cancel-account-dialog.component";
import { ReactivateAccountDialogComponent } from "./reactivate-account-dialog/reactivate-account-dialog.component";
import { PaymentHistoryDialogComponent } from "./payment-history-dialog/payment-history-dialog.component";
import { ContactSalesDialogComponent } from "./contact-sales-dialog/contact-sales-dialog.component";
import { ConfirmPlanDialogComponent } from "./confirm-plan-dialog/confirm-plan-dialog.component";
import { AddCouponDialogComponent } from "./add-coupon-dialog/add-coupon-dialog.component";
import { OcrPurchaseDialogComponent } from "./ocr-purchase-dialog/ocr-purchase-dialog.component";
import { BookingSubscriptionActivationDialogComponent } from "./booking-subscription-activation-dialog/booking-subscription-activation-dialog.component";
import { TpvSubscriptionActivationDialogComponent } from "./tpv-subscription-activation-dialog/tpv-subscription-activation-dialog.component";
import { BookingContextService } from "../../modules_v2/booking/services/booking-context.service";
import { FiscalProfileIssue, FiscalProfileService } from "../../modules_v2/shared/services/fiscal-profile.service";

declare let Stripe; // : stripe.StripeStatic;


@Component({
    selector: "convfact-subscriptionList",
    templateUrl: "./subscriptionList.component.html",
    styleUrls: ["./subscription.component.css", "./subscription.component_new.css"],
    standalone: false
})
export class SubscriptionListComponent implements OnInit {

  public StatusSubscription = STATUS_SUBSCRIPTION;

  status_screen: STATUS_SUBSCRIPTION = STATUS_SUBSCRIPTION.INIT;

  isLoading = false;
  isInitialPlanLoading = true;

  @Input() subscriptionList: SubscriptionModel[] = [];

  suscriptions: any[] = [];
  promotionModules: any[] = [];

  constructor(
    public snackBar: MatSnackBar,
    private userService: UserService,
    private dialogsService: DialogsService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private subscriptionService: SubscriptionService,
    public checkoutService: CheckoutService,
    private firstStepsDialogService: FirstStepsDialogService,
    private bookingContextService: BookingContextService,
    private fiscalProfileService: FiscalProfileService
  ) { }

  stripeKey: string = environment.stripePublicKey;
  stripe: any;
  sessionID: string;

  user: UserModel;

  completed = false;
  canceled = false;
  list = false;
  timeRemaining: number = 2000;

  upToDate = true;

  shopping_cart: any = {
    period: 'month',
    services: [],
    suscription: null,
    amount: 0
  }

  current_subscription;
  subscription_actives = [];
  billing_overview: any = null;
  isTpvActive: boolean = false;
  isTpvLoading: boolean = false;
  tpvNextRenewalDate: Date | null = null;
  tpvNextRenewalAmount: number | null = null;
  tpvCancelAtPeriodEnd: boolean = false;
  isBookingProActive: boolean = false;
  isBookingProLoading: boolean = false;
  bookingProNextRenewalDate: Date | null = null;
  bookingProNextRenewalAmount: number | null = null;
  bookingProCancelAtPeriodEnd: boolean = false;
  isBookingProActionLoading: boolean = false;
  bookingProLoadingHeader: string = '';
  bookingProLoadingBody: string = '';
  private pendingBookingActivationFromQuery: boolean = false;
  private bookingActivationDialogShownFromQuery: boolean = false;
  private pendingTpvActivationFromQuery: boolean = false;
  private tpvActivationDialogShownFromQuery: boolean = false;
  ocrQuantitySteps: number[] = [0, 50, 100, 200, 500, 1000];
  ocrSelectedIndex: number = 0;
  pendingDowngrade: any = null;
  isPendingDowngradeLoading: boolean = false;
  fiscalProfileIssues: FiscalProfileIssue[] = [];

  public displayMessage(text: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    this.snackBar.open(text, "", options);
  }

  private getPaymentErrorMessage(operationType: 'payment' | 'plan-change' | 'upgrade' | 'downgrade'): string {
    switch (operationType) {
      case 'plan-change':
        return 'No se ha podido cambiar al plan anual. Inténtalo de nuevo.';
      case 'upgrade':
        return 'No se ha podido actualizar el plan. Inténtalo de nuevo.';
      case 'downgrade':
        return 'No se ha podido cambiar el plan. Inténtalo de nuevo.';
      case 'payment':
      default:
        return 'No se ha podido procesar el pago. Inténtalo de nuevo.';
    }
  }

  public updateCardPayment() {
    this.isLoading = true;
    this.stripe = Stripe(this.stripeKey);

    this.checkoutService.createUpdateCardSession().then((response) => {
      if (response.error || response == '' || response == null) {
        this.isLoading = false;
        this.displayMessage('No se ha podido actualizar el método de pago. Inténtalo de nuevo.');
        return;
      }

      window.location.href = response;

      this.status_screen = STATUS_SUBSCRIPTION.SELECT_SERVICE;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      this.displayMessage('No se ha podido actualizar el método de pago. Inténtalo de nuevo.');
    });
  }

  public cancelAccount() {
    this.isLoading = true;
    this.stripe = Stripe(this.stripeKey);

    this.checkoutService.cancelAccount().then((response) => {
      if (response.error || response == '' || response == null) {
        this.isLoading = false;
        this.displayMessage('No se ha podido cancelar la cuenta. Inténtalo de nuevo.');
        return;
      }

      this.isLoading = false;
      this.displayMessage('Tu suscripción se ha cancelado correctamente. Podrás seguir usando Handly hasta el final del período actual.');
      
      // Actualizar la información del billing overview y suscripciones
      this.getBillingOverview();
      this.getSubscriptionActives();

      this.status_screen = STATUS_SUBSCRIPTION.SELECT_SERVICE;
    }).catch(error => {
      this.isLoading = false;
      this.displayMessage('No se ha podido cancelar la cuenta. Inténtalo de nuevo.');
    });
  }

  public pay(operationType: 'payment' | 'plan-change' | 'upgrade' | 'downgrade' = 'payment') {
    this.isLoading = true;
    this.stripe = Stripe(this.stripeKey);

    const isPlanChange = operationType === 'plan-change' || operationType === 'upgrade' || operationType === 'downgrade';
    const checkoutPromise = isPlanChange
      ? this.checkoutService.changeSubscriptionPlan(this.shopping_cart)
      : this.checkoutService.createCheckoutSessionId(this.shopping_cart);

    checkoutPromise.then((response) => {
      if (response.error || response == '' || response == null) {
        this.isLoading = false;
        this.displayMessage(this.getPaymentErrorMessage(operationType));
        return;
      }

      this.sessionID = response;
      if (this.sessionID != "" && this.sessionID != 'FREE_OK' && this.sessionID != 'OK') {
        this.stripe
          .redirectToCheckout({
            sessionId: this.sessionID,
          })
          .then((result) => {
            this.isLoading = false;
            this.getSubscriptionActives();
          }).catch((errors) => this.displayMessage(errors.error.message));
      } else if (this.sessionID == 'FREE_OK' || this.sessionID == 'OK') {

        // Si es cambio de plan, mostrar mensaje específico y recargar overview. El mensaje se basa
        // en el estado REAL devuelto por el backend (¿quedó un downgrade programado?), no en el
        // botón/operationType usado: un mismo 'plan-change' puede ser upgrade (inmediato) o
        // downgrade (programado para la próxima renovación), y antes se mostraba siempre el texto
        // de "próxima renovación" para 'plan-change' aunque fuera en realidad un upgrade instantáneo.
        if (operationType === 'plan-change' || operationType === 'upgrade' || operationType === 'downgrade') {
          this.isLoading = false;
          this.getBillingOverview();
          this.getSubscriptionActives();
          this.loadPendingDowngradeState().then(() => {
            const message = this.hasPendingDowngrade()
              ? 'El cambio de plan se aplicará en tu próxima renovación.'
              : 'El cambio de plan se ha realizado correctamente.';
            this.displayMessage(message);
          });
          return;
        }

        // Al activar el plan gratuito mostraremos el model de primeros pasos
        this.firstStepsDialogService.getEnableDisableFirstSteps()
          .then(responseFirstSteps => {
            if (responseFirstSteps.firstTime) {
              this.openFirstSteps(true);
            }
          });

        this.list = false;
        this.completed = true;
        this.status_screen = STATUS_SUBSCRIPTION.SUBSCRIPTION_OK;
        this.isLoading = false;
        setTimeout(this.hiddenCompletedMessage.bind(this), this.timeRemaining);
        setTimeout(this.getSubscriptionActives.bind(this), this.timeRemaining);
        return;
      } else {
        this.list = false;
        this.completed = true;
        this.status_screen = STATUS_SUBSCRIPTION.SUBSCRIPTION_OK;
        this.isLoading = false;
        setTimeout(this.hiddenCompletedMessage.bind(this), this.timeRemaining);
        setTimeout(this.getSubscriptionActives.bind(this), this.timeRemaining);
        return;
      }
    }).catch(error => {
      if (this.fiscalProfileService.handleError(error)) {
        this.isLoading = false;
        return;
      }

      const err = error.error || {};

      if (err.message != null && err.message.includes('SUBSCRIPTION_FREE_USED')) {

        this.isLoading = false;
        this.displayMessage('Ya has utilizado tu suscripción gratuita.');

      } else if (err.message != null && err.message.includes('SUBSCRIPTION_FREE_USED_NOT_VALID')) {

        this.isLoading = false;
        this.displayMessage('La suscripción gratuita no es válida.');

      } else {
        this.isLoading = false;
        this.displayMessage(this.getPaymentErrorMessage(operationType));
      }
    });
  }

  public payOCR() {
    this.isLoading = true;
    this.stripe = Stripe(this.stripeKey);

    this.checkoutService.createCheckoutOCRSessionId(this.shopping_cart).then((response) => {


      if (response.error || response == '' || response == null) {
        this.isLoading = false;
        this.displayMessage('No se ha podido procesar la compra de páginas OCR. Inténtalo de nuevo.');
        return;
      }

      this.sessionID = response;
      if (this.sessionID != "" && this.sessionID != 'OK') {
        this.stripe
          .redirectToCheckout({
            sessionId: this.sessionID,
          })
          .then((result) => {
            this.isLoading = false;
            this.getSubscriptionActives();
          }).catch((errors) => this.displayMessage(errors.error.message));
      } else if (this.sessionID == 'OK') {
        this.isLoading = false;
        this.getSubscriptionActives();
      } else {
        this.list = false;
        this.completed = true;
        this.status_screen = STATUS_SUBSCRIPTION.SUBSCRIPTION_OK;
        this.isLoading = false;
        this.getSubscriptionActives();
        setTimeout(this.hiddenCompletedMessage.bind(this), this.timeRemaining);
      }
    }).catch(error => {
      this.isLoading = false;
      if (this.fiscalProfileService.handleError(error)) {
        return;
      }
      this.displayMessage('No se ha podido procesar la compra de páginas OCR. Inténtalo de nuevo.');
    });
  }

  public ngOnInit() {
    const returningFromCheckout = !!this.route.snapshot.queryParams.subscription;

    this.route.queryParams.subscribe((params) => {
      if (params.subscription) {
        this.completed = true;
        setTimeout(this.hiddenCompletedMessage.bind(this), this.timeRemaining);

        // Al completar un pago se muestra el modal los primeros pasos
        this.firstStepsDialogService.getEnableDisableFirstSteps()
          .then(responseFirstSteps => {
            if (responseFirstSteps.firstTime) {
              this.openFirstSteps(true);
            }
          });
      }

      // Mostrar dialog de activación de booking si viene del módulo inactivo
      if (params.activateBooking === 'true') {
        this.pendingBookingActivationFromQuery = true;
      }

      // Mostrar dialog de activación de TPV si viene del módulo inactivo
      if (params.activateTpv === 'true') {
        this.pendingTpvActivationFromQuery = true;
      }
    });

    if (returningFromCheckout) {
      this.isInitialPlanLoading = true;
      this.subscriptionService.syncWithStripe().then(() => this.loadInitialPlanData());
    } else {
      this.loadInitialPlanData();
    }
    this.loadFiscalProfileStatus();

    this.userService.loadData().then((response) => {
      this.user = response;

      const url = this.router.url;
      const pieces = url.split("/");
      const pieces2 = pieces[1].split("?");

      if (pieces2.length > 1) {

        this.route.queryParams.subscribe((params) => {
          if (params.subscription) {
            this.completed = true;
          }
        });

      } else {
        this.list = true;
      }
    });

    this.upToDate = GetUserInfo.upToDate;

    this.shopping_cart.period = 'month';
    this.shopping_cart.services = [];
    this.syncOcrSelectionFromCart();
  }

  private loadFiscalProfileStatus(): void {
    this.fiscalProfileService.getStatus().subscribe({
      next: status => this.fiscalProfileIssues = status && !status.isComplete ? status.issues : [],
      error: () => this.fiscalProfileIssues = []
    });
  }

  hasFiscalProfileIssues(): boolean {
    return this.fiscalProfileIssues.length > 0;
  }

  completeFiscalProfile(): void {
    this.fiscalProfileService.goToComplete(this.fiscalProfileIssues);
  }

  private syncOcrSelectionFromCart(): void {
    const currentQuantity = this.shopping_cart && this.shopping_cart.quantity ? Number(this.shopping_cart.quantity) : 0;
    const index = this.ocrQuantitySteps.indexOf(currentQuantity);
    this.ocrSelectedIndex = index >= 0 ? index : 0;
  }

  getSelectedOcrPages(): number {
    if (this.ocrSelectedIndex < 0 || this.ocrSelectedIndex >= this.ocrQuantitySteps.length) {
      return 0;
    }

    return this.ocrQuantitySteps[this.ocrSelectedIndex];
  }

  getSelectedOcrOneTimeCost(): number {
    return this.getSelectedOcrPages() * 0.15;
  }

  onOcrRangeChanged(): void {
    const selectedPages = this.getSelectedOcrPages();
    const previousPages = this.shopping_cart && this.shopping_cart.quantity ? Number(this.shopping_cart.quantity) : 0;
    const selectedOneTimeCost = this.getSelectedOcrOneTimeCost();

    if (selectedPages === previousPages) {
      return;
    }

    if (selectedPages <= 0) {
      this.shopping_cart.quantity = 0;
      this.updateTotalAmount();
      return;
    }

    const dialogRef = this.dialog.open(OcrPurchaseDialogComponent, {
      width: "430px",
      maxWidth: "95vw",
      autoFocus: false,
      data: {
        pages: selectedPages,
        oneTimeCost: selectedOneTimeCost,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed === true) {
        this.shopping_cart.quantity = selectedPages;
        this.payOCR();
        return;
      }

      const previousIndex = this.ocrQuantitySteps.indexOf(previousPages);
      this.ocrSelectedIndex = previousIndex >= 0 ? previousIndex : 0;
    });
  }

  private loadInitialPlanData(): void {
    this.isInitialPlanLoading = true;

    Promise.all([
      this.loadSubscriptionCards().catch(() => null),
      this.loadPromotionCards().catch(() => null),
      this.getSubscriptionActives().catch(() => null),
      this.getBillingOverview().catch(() => null),
      this.loadTpvState().catch(() => null),
      this.loadBookingProState().catch(() => null),
      this.loadPendingDowngradeState().catch(() => null)
    ]).then(() => {
      this.isInitialPlanLoading = false;
      this.maybeShowBookingActivationFromQuery();
      this.maybeShowTpvActivationFromQuery();
    }).catch(() => {
      this.isInitialPlanLoading = false;
      this.maybeShowBookingActivationFromQuery();
      this.maybeShowTpvActivationFromQuery();
    });
  }

  private loadSubscriptionCards(): Promise<void> {
    return this.subscriptionService.getSubscriptionList().then(response => {
      this.subscriptionList = response || [];

      const expectedOrder = ['SUBSCRIPTION_BILLING', 'SUBSCRIPTION_SELF', 'SUBSCRIPTION_COMPANY'];
      const orderByAlias = expectedOrder.reduce((acc, alias, index) => {
        acc[alias] = index;
        return acc;
      }, {} as { [key: string]: number });

      this.suscriptions = (this.subscriptionList || [])
        .filter(item => item && expectedOrder.indexOf(item.type) >= 0)
        .sort((a, b) => {
          const orderA = orderByAlias[a.type] !== undefined ? orderByAlias[a.type] : 999;
          const orderB = orderByAlias[b.type] !== undefined ? orderByAlias[b.type] : 999;
          return orderA - orderB;
        })
        .map(item => {
          const features = Array.isArray(item.features)
            ? item.features.map((feature: SubscriptionFeatureModel) => ({
              description: feature.description,
              included: !!feature.included,
              bold: !!feature.bold
            }))
            : [];

          return {
            id: item.type,
            title: item.displayTitle || '',
            subtitle: item.displaySubtitle || '',
            originalPrice: item.originalPrice != null ? Number(item.originalPrice) : Number(item.price || 0),
            amount: Number(item.price || 0),
            features: features
          };
        });
    }).catch(() => {
      this.subscriptionList = [];
      this.suscriptions = [];
      return Promise.resolve();
    });
  }

  private loadBookingProState(): Promise<void> {
    this.isBookingProLoading = true;

    return new Promise((resolve) => {
      this.bookingContextService.getBookingMerchantStatus().subscribe(
        response => {
          this.isBookingProActive = !!(response && response.isSuccess && response.value && response.value.isActive);
          if (this.isBookingProActive) {
            this.loadBookingProRenewalInfo();
          }
          this.isBookingProLoading = false;
          resolve();
        },
        () => {
          this.isBookingProActive = false;
          this.isBookingProLoading = false;
          resolve();
        }
      );
    });
  }

  private loadPromotionCards(): Promise<void> {
    return this.subscriptionService.getPromotionsCatalog().then(response => {
      this.promotionModules = (response || [])
        .filter(item => item && item.id)
        .map(item => ({
          id: item.id,
          title: item.title || '',
          description: item.description || '',
          amount: Number(item.amount || item.price || 0),
          originalPrice: Number(item.originalPrice || 0),
          icon: item.icon || '📦'
        }));
    }).catch(() => {
      this.promotionModules = [];
      return Promise.resolve();
    });
  }

  private getBookingProMonthlyPrice(): number {
    const bookingPro = (this.promotionModules || []).find(module => module && module.id === 'BOOKING_PRO');
    if (!bookingPro) {
      return 0;
    }

    const amount = Number(bookingPro.amount || 0);
    if (amount > 0) {
      return amount;
    }

    return Number(bookingPro.originalPrice || 0);
  }

  private maybeShowBookingActivationFromQuery(): void {
    if (!this.pendingBookingActivationFromQuery || this.bookingActivationDialogShownFromQuery || this.isInitialPlanLoading) {
      return;
    }

    this.bookingActivationDialogShownFromQuery = true;
    this.pendingBookingActivationFromQuery = false;
    this.showBookingActivationDialogAutomatically();
  }

  private getTpvMonthlyPrice(): number {
    const tpv = (this.promotionModules || []).find(module => module && module.id === 'TPV');
    if (!tpv) {
      return 0;
    }

    const amount = Number(tpv.amount || 0);
    if (amount > 0) {
      return amount;
    }

    return Number(tpv.originalPrice || 0);
  }

  private maybeShowTpvActivationFromQuery(): void {
    if (!this.pendingTpvActivationFromQuery || this.tpvActivationDialogShownFromQuery || this.isInitialPlanLoading) {
      return;
    }

    this.tpvActivationDialogShownFromQuery = true;
    this.pendingTpvActivationFromQuery = false;
    this.showTpvActivationDialogAutomatically();
  }

  getPromotionNextRenewalDate(module: any): Date | null {
    if (!module || !module.id) {
      return null;
    }

    if (module.id === 'TPV') {
      return this.tpvNextRenewalDate;
    }

    if (module.id === 'BOOKING_PRO') {
      return this.bookingProNextRenewalDate;
    }

    return null;
  }

  getPromotionNextRenewalAmount(module: any): number | null {
    if (!module || !module.id) {
      return null;
    }

    if (module.id === 'TPV') {
      return this.tpvNextRenewalAmount;
    }

    if (module.id === 'BOOKING_PRO') {
      return this.bookingProNextRenewalAmount;
    }

    return null;
  }

  isPromotionScheduledForCancellation(module: any): boolean {
    if (!module || !module.id) {
      return false;
    }

    if (module.id === 'TPV') {
      return this.tpvCancelAtPeriodEnd;
    }

    if (module.id === 'BOOKING_PRO') {
      return this.bookingProCancelAtPeriodEnd;
    }

    return false;
  }

  isPromotionActive(module: any): boolean {
    if (!module || !module.id) {
      return false;
    }

    if (module.id === 'TPV') {
      return this.isTpvActive;
    }

    if (module.id === 'BOOKING_PRO') {
      return this.isBookingProActive;
    }

    return false;
  }

  isPromotionLoading(module: any): boolean {
    if (!module || !module.id) {
      return false;
    }

    if (module.id === 'TPV') {
      return this.isTpvLoading;
    }

    if (module.id === 'BOOKING_PRO') {
      return this.isBookingProLoading;
    }

    return false;
  }

  onTogglePromotion(module: any): void {
    if (!module || !module.id) {
      return;
    }

    if (module.id === 'TPV') {
      this.onToggleTpv();
      return;
    }

    if (module.id === 'BOOKING_PRO') {
      this.onToggleBookingPro();
      return;
    }
  }

  private loadTpvState(): Promise<void> {
    this.isTpvLoading = true;

    return this.subscriptionService.getTpvSubscriptionStatus().then(response => {
      const value = response && response.isSuccess ? response.value : null;
      this.isTpvActive = !!(value && value.isActive);
      this.tpvNextRenewalDate = value && value.nextRenewalDate ? new Date(value.nextRenewalDate) : null;
      this.tpvNextRenewalAmount = value && value.nextRenewalAmount != null ? Number(value.nextRenewalAmount) : null;
      this.tpvCancelAtPeriodEnd = !!(value && value.cancelAtPeriodEnd);
      this.isTpvLoading = false;
    }).catch(() => {
      this.isTpvActive = false;
      this.tpvNextRenewalDate = null;
      this.tpvNextRenewalAmount = null;
      this.tpvCancelAtPeriodEnd = false;
      this.isTpvLoading = false;
    });
  }

  private loadPendingDowngradeState(): Promise<void> {
    this.isPendingDowngradeLoading = true;

    return this.subscriptionService.getBaseSubscriptionStatus().then(response => {
      const value = response && response.isSuccess ? response.value : null;
      this.pendingDowngrade = value && value.hasPendingDowngrade ? value : null;
      this.isPendingDowngradeLoading = false;
    }).catch(() => {
      this.pendingDowngrade = null;
      this.isPendingDowngradeLoading = false;
    });
  }

  hasPendingDowngrade(): boolean {
    return !!this.pendingDowngrade;
  }

  getPendingDowngradePlanTitle(): string {
    if (!this.pendingDowngrade) {
      return '';
    }

    const alias = this.pendingDowngrade.pendingDowngradePlanAlias;
    const match = (this.suscriptions || []).find(s => s.id === alias);
    return match ? match.title : alias;
  }

  getPendingDowngradeIntervalText(): string {
    return this.pendingDowngrade && this.pendingDowngrade.pendingDowngradeInterval === 'year' ? 'anual' : 'mensual';
  }

  getPendingDowngradeEffectiveDate(): Date | null {
    return this.pendingDowngrade && this.pendingDowngrade.pendingDowngradeEffectiveDate
      ? new Date(this.pendingDowngrade.pendingDowngradeEffectiveDate)
      : null;
  }

  onCancelPendingDowngrade(): void {
    if (this.isPendingDowngradeLoading) {
      return;
    }

    this.dialogsService
      .confirm(
        '¿Cancelar el cambio de plan programado?',
        'Seguirás disfrutando de tu plan actual sin interrupciones.'
      )
      .subscribe((res: boolean) => {
        if (res !== true) {
          return;
        }

        this.isPendingDowngradeLoading = true;
        this.subscriptionService.cancelPendingDowngrade().then(() => {
          this.pendingDowngrade = null;
          this.isPendingDowngradeLoading = false;
          this.displayMessage('Cambio de plan cancelado. Sigues en tu plan actual.');
          // El banner de downgrade pendiente ya se limpia arriba, pero "Próxima renovación" del
          // header sale de billing_overview (endpoint aparte) y se queda con el importe/plan viejo
          // si no se recarga explícitamente.
          this.getBillingOverview();
          this.getSubscriptionActives();
        }).catch(() => {
          this.isPendingDowngradeLoading = false;
          this.displayMessage('No se ha podido cancelar el cambio de plan. Inténtalo de nuevo.');
        });
      });
  }

  private loadBookingProRenewalInfo(): void {
    this.subscriptionService.getBookingSubscriptionStatus().then(response => {
      const value = response && response.isSuccess ? response.value : null;
      this.bookingProNextRenewalDate = value && value.nextRenewalDate ? new Date(value.nextRenewalDate) : null;
      this.bookingProNextRenewalAmount = value && value.nextRenewalAmount != null ? Number(value.nextRenewalAmount) : null;
      this.bookingProCancelAtPeriodEnd = !!(value && value.cancelAtPeriodEnd);
    }).catch(() => {
      this.bookingProNextRenewalDate = null;
      this.bookingProNextRenewalAmount = null;
      this.bookingProCancelAtPeriodEnd = false;
    });
  }

  onToggleTpv(): void {
    if (this.isTpvLoading) {
      return;
    }

    if (this.isTpvActive) {
      this.isTpvLoading = true;
      this.isBookingProActionLoading = true;
      this.bookingProLoadingHeader = 'Desactivando TPV';
      this.bookingProLoadingBody = 'Por favor espera un momento…';

      this.subscriptionService.deactivateTpvSubscription().then(response => {
        const value = response && response.isSuccess ? response.value : null;
        this.tpvCancelAtPeriodEnd = !!(value && value.deactivated);
        this.isTpvLoading = false;
        this.isBookingProActionLoading = false;
        this.displayMessage('TPV se cancelará al final del periodo ya pagado.');
        this.loadTpvState();
      }).catch(() => {
        this.isTpvLoading = false;
        this.isBookingProActionLoading = false;
        this.displayMessage('No se ha podido desactivar TPV. Inténtalo de nuevo.');
      });

      return;
    }

    const dialogRef = this.dialog.open(TpvSubscriptionActivationDialogComponent, {
      width: '480px',
      maxWidth: '95vw',
      autoFocus: false,
      data: {
        monthlyPrice: this.getTpvMonthlyPrice()
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed !== true) {
        return;
      }

      this.isTpvLoading = true;
      this.isBookingProActionLoading = true;
      this.bookingProLoadingHeader = 'Activando TPV';
      this.bookingProLoadingBody = 'Redirigiendo a pago…';

      this.subscriptionService.activateTpvSubscriptionCheckout().then(checkoutResponse => {
        this.isTpvLoading = false;
        this.isBookingProActionLoading = false;
        this.isTpvActive = true;

        if (checkoutResponse && checkoutResponse.isSuccess && checkoutResponse.value && (checkoutResponse.value.checkoutUrl || checkoutResponse.value.sessionId || checkoutResponse.value.checkoutSessionId)) {
          if (checkoutResponse.value.checkoutUrl) {
            window.location.href = checkoutResponse.value.checkoutUrl;
          } else {
            this.displayMessage('Checkout de TPV iniciado');
          }
        } else {
          this.displayMessage('No se ha podido iniciar el checkout de TPV. Inténtalo de nuevo.');
          this.isTpvActive = false;
        }
      }).catch(error => {
        this.isTpvLoading = false;
        this.isBookingProActionLoading = false;
        if (this.fiscalProfileService.handleError(error)) {
          return;
        }
        this.displayMessage('No se ha podido iniciar el checkout de TPV. Inténtalo de nuevo.');
      });
    });
  }

  onToggleBookingPro(): void {
    if (this.isBookingProLoading) {
      return;
    }

    if (this.isBookingProActive) {
      this.isBookingProLoading = true;
      this.isBookingProActionLoading = true;
      this.bookingProLoadingHeader = 'Desactivando Reservas PRO';
      this.bookingProLoadingBody = 'Por favor espera un momento…';

      this.bookingContextService.deactivateBookingMerchant().subscribe(
        response => {
          this.isBookingProActive = !(response && response.isSuccess && response.value && response.value.deactivated);
          this.isBookingProLoading = false;
          this.isBookingProActionLoading = false;
          this.displayMessage('Reservas PRO desactivado correctamente');
        },
        () => {
          this.isBookingProLoading = false;
          this.isBookingProActionLoading = false;
          this.displayMessage('No se ha podido desactivar Reservas PRO. Inténtalo de nuevo.');
        }
      );

      return;
    }

    const dialogRef = this.dialog.open(BookingSubscriptionActivationDialogComponent, {
      width: '480px',
      maxWidth: '95vw',
      autoFocus: false,
      data: {
        monthlyPrice: this.getBookingProMonthlyPrice()
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed !== true) {
        return;
      }

      this.isBookingProLoading = true;
      this.isBookingProActionLoading = true;
      this.bookingProLoadingHeader = 'Activando Reservas PRO';
      this.bookingProLoadingBody = 'Redirigiendo a pago…';

      this.bookingContextService.activateBookingSubscriptionCheckout().subscribe(
        checkoutResponse => {
          this.isBookingProLoading = false;
          this.isBookingProActionLoading = false;
          this.isBookingProActive = true;

          // Si el backend devuelve datos de checkout, redirigir
          if (checkoutResponse && checkoutResponse.isSuccess && checkoutResponse.value && (checkoutResponse.value.checkoutUrl || checkoutResponse.value.sessionId || checkoutResponse.value.checkoutSessionId)) {
            // Si hay checkoutUrl, ir directo
            if (checkoutResponse.value.checkoutUrl) {
              window.location.href = checkoutResponse.value.checkoutUrl;
            } else {
              // En caso contrario, el checkout se abrirá en Stripe.js si está configurado
              this.displayMessage('Checkout de Reservas PRO iniciado');
            }
          } else {
            this.displayMessage('No se ha podido iniciar el checkout. Inténtalo de nuevo.');
            this.isBookingProActive = false;
          }
        },
        error => {
          this.isBookingProLoading = false;
          this.isBookingProActionLoading = false;
          if (this.fiscalProfileService.handleError(error)) {
            return;
          }
          console.error('Error in booking subscription checkout:', error);
          this.displayMessage('No se ha podido iniciar el checkout. Inténtalo de nuevo.');
        }
      );
    });

  }

  private showBookingActivationDialogAutomatically(): void {
    setTimeout(() => {
      const dialogRef = this.dialog.open(BookingSubscriptionActivationDialogComponent, {
        width: '480px',
        maxWidth: '95vw',
        autoFocus: false,
        data: {
          monthlyPrice: this.getBookingProMonthlyPrice()
        }
      });

      // Limpiar el query param para no reabrir el dialog en recargas o navegación.
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { activateBooking: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed !== true) {
          return;
        }

        this.isBookingProLoading = true;
        this.isBookingProActionLoading = true;
        this.bookingProLoadingHeader = 'Activando Reservas PRO';
        this.bookingProLoadingBody = 'Redirigiendo a pago…';

        this.bookingContextService.activateBookingSubscriptionCheckout().subscribe(
          checkoutResponse => {
            this.isBookingProLoading = false;
            this.isBookingProActionLoading = false;
            this.isBookingProActive = true;

            // Si el backend devuelve datos de checkout, redirigir
            if (checkoutResponse && checkoutResponse.isSuccess && checkoutResponse.value && (checkoutResponse.value.checkoutUrl || checkoutResponse.value.sessionId || checkoutResponse.value.checkoutSessionId)) {
              // Si hay checkoutUrl, ir directo
              if (checkoutResponse.value.checkoutUrl) {
                window.location.href = checkoutResponse.value.checkoutUrl;
              } else {
                // En caso contrario, el checkout se abrirá en Stripe.js si está configurado
                this.displayMessage('Checkout de Reservas PRO iniciado');
              }
            } else {
              this.displayMessage('No se ha podido iniciar el checkout. Inténtalo de nuevo.');
              this.isBookingProActive = false;
            }
          },
          error => {
            this.isBookingProLoading = false;
            this.isBookingProActionLoading = false;
            if (this.fiscalProfileService.handleError(error)) {
              return;
            }
            console.error('Error in booking subscription checkout:', error);
            this.displayMessage('No se ha podido iniciar el checkout. Inténtalo de nuevo.');
          }
        );
      });
    }, 300); // Pequeño delay para que el template se renderice primero
  }

  private showTpvActivationDialogAutomatically(): void {
    setTimeout(() => {
      const dialogRef = this.dialog.open(TpvSubscriptionActivationDialogComponent, {
        width: '480px',
        maxWidth: '95vw',
        autoFocus: false,
        data: {
          monthlyPrice: this.getTpvMonthlyPrice()
        }
      });

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { activateTpv: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed !== true) {
          return;
        }

        this.isTpvLoading = true;
        this.isBookingProActionLoading = true;
        this.bookingProLoadingHeader = 'Activando TPV';
        this.bookingProLoadingBody = 'Redirigiendo a pago…';

        this.subscriptionService.activateTpvSubscriptionCheckout().then(checkoutResponse => {
          this.isTpvLoading = false;
          this.isBookingProActionLoading = false;
          this.isTpvActive = true;

          if (checkoutResponse && checkoutResponse.isSuccess && checkoutResponse.value && (checkoutResponse.value.checkoutUrl || checkoutResponse.value.sessionId || checkoutResponse.value.checkoutSessionId)) {
            if (checkoutResponse.value.checkoutUrl) {
              window.location.href = checkoutResponse.value.checkoutUrl;
            } else {
              this.displayMessage('Checkout de TPV iniciado');
            }
          } else {
            this.displayMessage('No se ha podido iniciar el checkout de TPV. Inténtalo de nuevo.');
            this.isTpvActive = false;
          }
        }).catch(error => {
          this.isTpvLoading = false;
          this.isBookingProActionLoading = false;
          if (this.fiscalProfileService.handleError(error)) {
            return;
          }
          this.displayMessage('No se ha podido iniciar el checkout de TPV. Inténtalo de nuevo.');
        });
      });
    }, 300);
  }

  getSubscriptionActives() {
    return this.subscriptionService.getActive().then(response => {
      this.subscription_actives = response;

      if (this.subscription_actives.length > 0) {
        this.current_subscription = this.subscription_actives.filter(c => c.type == 'FEE')[0];

        if (this.isCurrentFree()) {
          this.status_screen = STATUS_SUBSCRIPTION.SELECT_FEE;
        } else {
          this.status_screen = STATUS_SUBSCRIPTION.SELECT_SERVICE;
          this.shopping_cart.suscription = null;
          this.shopping_cart.amount = 0;
          // El catálogo debe mostrar el precio del periodo en el que el usuario ya está
          // suscrito (mensual/anual), no siempre mensual por defecto.
          this.shopping_cart.period = this.current_subscription && this.current_subscription.interval === 'year'
            ? 'year'
            : 'month';
          this.setNewSuscriptionToUser(response);
        }
      } else {
        this.status_screen = STATUS_SUBSCRIPTION.SELECT_FEE;
        this.shopping_cart.suscription = null;
        this.shopping_cart.amount = 0;
        this.setNewSuscriptionToUser(response);

      }
      return response;
    }).catch(error => {
      this.subscription_actives = [];
      this.current_subscription = null;
      this.status_screen = STATUS_SUBSCRIPTION.SELECT_FEE;
      return Promise.reject(error);
    });
  }

  private setNewSuscriptionToUser(response: any[]): void {
    const userPermissions: string[] = ['SUBSCRIPTION_FREE', 'SUBSCRIPTION_BILLING', 'SUBSCRIPTION_SELF', 'SUBSCRIPTION_COMPANY'];

    response.forEach(s => {
      if (userPermissions.includes(s.alias)) {
        GetUserInfo.subscriptionTypes = s.alias;
      }
    });
  }

  getBillingOverview() {
    return this.subscriptionService.getBillingOverview().then(response => {
      this.billing_overview = response;
      // Si es modo trial, asegurar que no se muestra el overlay sino la pantalla principal
      if (this.isTrialMode()) {
        this.status_screen = STATUS_SUBSCRIPTION.SELECT_SERVICE;
      }
      return response;
    }).catch(() => {
      this.billing_overview = null;
      return null;
    });
  }

  private getBillingValue(...keys: string[]): any {
    if (!this.billing_overview) {
      return null;
    }

    for (const key of keys) {
      if (this.billing_overview[key] !== undefined && this.billing_overview[key] !== null) {
        return this.billing_overview[key];
      }
    }

    return null;
  }

  getHeaderPlanName(): string {
    if (this.hasNoActiveSubscription()) {
      return 'Sin suscripción activa';
    }

    const planName = this.getBillingValue('planName', 'PlanName');
    if (planName) {
      return planName;
    }

    return 'Plan actual';
  }

  getHeaderStatusLabel(): string {
    const statusValue = this.getBillingValue('status', 'Status');
    const status = statusValue
      ? statusValue.toString().toLowerCase()
      : '';

    switch (status) {
      case 'active':
        return 'Suscripción activa';
      case 'trialing':
        return 'Periodo de prueba';
      case 'past_due':
        return 'Pago pendiente';
      case 'incomplete':
        return 'Pago incompleto';
      case 'unpaid':
        return 'Impagada';
      case 'canceled':
      case 'cancelled':
        return 'Cancelada';
      case 'trial':
        return 'Modo de prueba';
      default:
        return 'Sin suscripción activa';
    }
  }

  isTrialMode(): boolean {
    return this.getBillingValue('isTrial', 'IsTrial') === true;
  }

  isCanceledStatus(): boolean {
    const statusValue = this.getBillingValue('status', 'Status');
    const status = statusValue ? statusValue.toString().toLowerCase().trim() : '';
    return status === 'canceled' || status === 'cancelled';
  }

  isScheduledForCancellation(): boolean {
    return this.getBillingValue('cancelAtPeriodEnd', 'CancelAtPeriodEnd') === true;
  }

  isInlinePlanSelectionMode(): boolean {
    return this.isTrialMode() || this.hasNoActiveSubscription();
  }

  getTrialDaysRemaining(): number {
    return this.getBillingValue('trialDaysRemaining', 'TrialDaysRemaining') || 0;
  }

  getTrialPeriodEnd(): Date | null {
    const trialPeriodEnd = this.getBillingValue('trialPeriodEnd', 'TrialPeriodEnd');
    return trialPeriodEnd ? new Date(trialPeriodEnd) : null;
  }

  getHeaderMonthlyPrice(): number {
    if (this.isTrialMode()) {
      return 0;
    }

    // Siempre mostrar el precio base de la suscripción (sin descuento)
    const currentPrice = this.getBillingValue('currentPrice', 'CurrentPrice');
    if (currentPrice != null) {
      return Number(currentPrice);
    }

    return 0;
  }

  hasHeaderDiscount(): boolean {
    return Boolean(this.getBillingValue('hasDiscount', 'HasDiscount'));
  }

  getHeaderBasePrice(): number {
    const currentPrice = this.getBillingValue('currentPrice', 'CurrentPrice');
    return currentPrice != null ? Number(currentPrice) : 0;
  }

  getHeaderDiscountName(): string {
    const discountName = this.getBillingValue('discountName', 'DiscountName');
    return discountName ? discountName.toString() : '';
  }

  getHeaderNextRenewalDate(): any {
    const dateValue = this.getBillingValue('nextRenewalDate', 'NextRenewalDate');
    if (dateValue) {
      // Si es string, convertir a Date
      if (typeof dateValue === 'string') {
        return new Date(dateValue);
      }
      return dateValue;
    }
    return null;
  }

  getHeaderNextRenewalAmount(): number {
    // Retorna el monto del próximo pago (con descuento si aplica)
    const hasDiscount = this.hasHeaderDiscount();
    const effectivePrice = this.getBillingValue('effectivePrice', 'EffectivePrice');

    if (hasDiscount && effectivePrice != null) {
      return Number(effectivePrice);
    }

    const currentPrice = this.getBillingValue('currentPrice', 'CurrentPrice');
    if (currentPrice != null) {
      return Number(currentPrice);
    }

    return 0;
  }

  openConfirmPlanDialog(): void {
    // Cerramos el overlay de selección de plan primero
    this.status_screen = this.StatusSubscription.SELECT_SERVICE;

    // Esperamos a que Angular procese el cambio de estado antes de abrir el dialog
    setTimeout(() => {
      const dialogRef = this.dialog.open(ConfirmPlanDialogComponent, {
        width: '480px',
        maxWidth: '95vw',
        autoFocus: false,
        panelClass: 'dialog-no-scroll',
        data: {
          plan: this.shopping_cart.suscription,
          period: this.shopping_cart.period,
          total: this.getTotal(),
          billingText: this.getBillingText(),
          couponApplied: this.shopping_cart.couponApplied,
          couponCode: this.shopping_cart.couponCode,
          couponDiscount: this.getCouponAmountDiscount(),
          isPlanChange: !this.isCurrentFree()
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        const confirmed = !!result && result.confirmed === true;
        this.shopping_cart.prorationDate = confirmed ? result.prorationDate : null;
        if (confirmed) {
          // openConfirmPlanDialog se usa en DOS flujos: el botón "Continuar" del carrito para
          // usuarios SIN suscripción (alta nueva) y el Caso 2 de onSelectSuscription (cambio de
          // plan, usuario ya suscrito). Hay que enrutar según cuál es, si no el alta intenta
          // cambiar un plan inexistente (409) o el cambio de plan crea un checkout duplicado.
          if (this.isCurrentFree()) {
            this.pay();
          } else {
            this.pay('plan-change');
          }
        } else {
          // Volver: reabrimos el overlay de selección de plan
          this.status_screen = this.StatusSubscription.SELECT_FEE;
        }
      });
    }, 0);
  }

  openContactSalesDialog(): void {
    // Cerramos el overlay de selección de plan primero
    this.status_screen = this.StatusSubscription.SELECT_SERVICE;

    setTimeout(() => {
      const dialogRef = this.dialog.open(ContactSalesDialogComponent, {
        width: '720px',
        height: 'auto',
        maxWidth: '95vw',
        autoFocus: false,
        panelClass: 'dialog-no-scroll'
      });

      dialogRef.afterClosed().subscribe(() => {
        this.status_screen = this.StatusSubscription.SELECT_FEE;
      });
    }, 0);
  }

  openPaymentHistoryDialog(): void {
    const paymentHistory = this.getBillingValue('paymentHistory', 'PaymentHistory');
    if (paymentHistory && paymentHistory.length > 0) {
      this.dialog.open(PaymentHistoryDialogComponent, {
        width: '800px',
        maxWidth: '95vw',
        data: {
          paymentHistory: paymentHistory
        }
      });
    } else {
      this.snackBar.open('No hay histórico de pagos disponible', 'Cerrar', {
        duration: 3000
      });
    }
  }

  reActivate(id: string) {
    const dialogRef = this.dialog.open(ReactivateAccountDialogComponent, {
      width: '580px',
      maxWidth: '95vw',
      disableClose: false,
      data: {}
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result === true) {
        this.isLoading = true;
        this.checkoutService
          .reActivateStripeSubscription(id)
          .then((response) => {
            this.isLoading = false;
            this.displayMessage('🎉 ¡Genial! Tu suscripción ha sido reactivada con éxito. Nos alegra tenerte de vuelta.');
            this.getSubscriptionActives();
            this.getBillingOverview();
          })
          .catch((errors) => {
            this.isLoading = false;
            if (this.fiscalProfileService.handleError(errors)) {
              return;
            }
            const errorMessage = (errors.error && errors.error.message) 
              ? errors.error.message 
              : 'No se ha podido reactivar la suscripción. Inténtalo de nuevo.';
            this.displayMessage(errorMessage);
          });
      }
    });
  }

  hiddenCompletedMessage() {
    this.completed = false;
    this.canceled = false;
    this.status_screen = STATUS_SUBSCRIPTION.SELECT_SERVICE;
  }

  onSelectMonthPeriod() {
    this.shopping_cart.period = 'month';
    this.updateCoupon();
    this.updateTotalAmount();
  }

  onSelectAnualPeriod() {
    this.shopping_cart.period = 'year';
    this.updateCoupon();
    this.updateTotalAmount();
  }

  onSelectSuscription(item: any) {
    // Si NO es free, es porque ya tiene un plan de pago y está actualizando
    const isUpdating = !this.isCurrentFree();

    // === Caso 1: no tiene plan de pago (FREE / primer alta) ===
    if (!isUpdating) {
      // Solo marcamos el plan en el carrito y actualizamos el resumen
      this.shopping_cart.suscription = item;

      // Si no hay periodo, por defecto mensual
      if (!this.shopping_cart.period || this.shopping_cart.period === 'none') {
        this.shopping_cart.period = 'month';
      }

      this.updateCoupon();
      this.updateTotalAmount();
      return;
    }

    // === Caso 2: ya tiene plan de pago -> cambio de plan ===
    this.shopping_cart.suscription = item;
    if (!this.shopping_cart.period || this.shopping_cart.period === 'none') {
      this.shopping_cart.period = this.current_subscription && this.current_subscription.interval === 'year'
        ? 'year'
        : 'month';
    }
    this.tryApplyCouponForActiveSelection().then(() => {
      this.openConfirmPlanDialog();
    });
    return;
  }

  isSuscriptionSelected(item: any) {
    if (this.user != null && this.user.subscriptionType === 'FEE' && this.user.subscriptionAlias === 'SUBSCRIPTION_FREE') {
      return this.user.subscriptionAlias == item.id;
    }

    if (this.shopping_cart.suscription == null) {
      return false;
    }

    return this.shopping_cart.suscription.id == item.id;
  }

  updateTotalAmount() {

    if (!this.shopping_cart) {
      return;
    }

    this.shopping_cart.amount = 0;

    // Plan principal
    if (this.shopping_cart.suscription) {
      this.shopping_cart.suscription.total = this.getSubscriptionAmount();
      this.shopping_cart.amount += this.shopping_cart.suscription.total;
    }

    // Servicios adicionales
    if (this.shopping_cart.services && this.shopping_cart.services.length > 0) {
      this.shopping_cart.amount += this.shopping_cart.services.reduce(function (acc, item) {
        item.total = item.amount;
        return acc + item.total;
      }, 0);
    }

    // OCR (si quieres que también sume aquí)
    this.shopping_cart.amount += this.getOcrTotal();
  }

  getAmountSelected(amount) {
    return new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
  }

  private hasActivePaidSubscription(): boolean {
    return !!(this.subscription_actives
      && this.subscription_actives.length > 0
      && this.subscription_actives.some(x => x && x.type == 'FEE' && x.alias != 'SUBSCRIPTION_FREE' && x.dateCancel == null));
  }

  isCurrentFree() {
    if (this.hasActivePaidSubscription()) {
      return false;
    }

    return this.current_subscription == null || this.current_subscription.alias == 'SUBSCRIPTION_FREE';
  }

  hasNoActiveSubscription(): boolean {
    if (this.isTrialMode() || !this.billing_overview) {
      return false;
    }

    const subscriptionId = this.getBillingValue('subscriptionId', 'SubscriptionId');
    const statusValue = this.getBillingValue('status', 'Status');
    const status = statusValue ? statusValue.toString().toLowerCase().trim() : '';

    if (!subscriptionId && (status === '' || status === 'none' || status === 'null')) {
      return true;
    }

    return status === 'canceled' || status === 'cancelled';
  }

  // === Pago pendiente (suscripción vencida no cancelada: past_due / unpaid / incomplete) ===

  private getPaymentStatus(): string {
    var statusValue = this.getBillingValue('status', 'Status');
    return statusValue ? statusValue.toString().toLowerCase().trim() : '';
  }

  isPastDueStatus(): boolean {
    var status = this.getPaymentStatus();
    return status === 'past_due' || status === 'unpaid' || status === 'incomplete';
  }

  hasPaymentIssue(): boolean {
    return this.getBillingValue('hasPaymentIssue', 'HasPaymentIssue') === true;
  }

  // Cuando hay un impago sobre una suscripción existente (no cancelada, no trial)
  // debemos dejar regularizar el pago en vez de obligar a contratar un plan nuevo.
  isPaymentPendingMode(): boolean {
    if (!this.billing_overview) {
      return false;
    }
    if (this.isTrialMode() || this.hasNoActiveSubscription()) {
      return false;
    }
    return this.hasPaymentIssue() || this.isPastDueStatus();
  }

  getPaymentIssueMessage(): string {
    var message = this.getBillingValue('paymentIssueMessage', 'PaymentIssueMessage');
    if (message) {
      return message.toString();
    }
    return 'Tu suscripción tiene un pago pendiente. Regulariza el pago para reactivar tu cuenta.';
  }

  getHostedInvoiceUrl(): string {
    var url = this.getBillingValue('hostedInvoiceUrl', 'HostedInvoiceUrl');
    return url ? url.toString() : '';
  }

  // Motivo concreto del impago (rechazo de tarjeta de Stripe), traducido a español.
  // Devuelve '' cuando no hay un motivo específico (p. ej. factura simplemente impagada).
  getPaymentIssueReason(): string {
    var declineCode = this.getBillingValue('paymentIssueDeclineCode', 'PaymentIssueDeclineCode');
    var code = this.getBillingValue('paymentIssueCode', 'PaymentIssueCode');

    var key = (declineCode || code || '').toString().toLowerCase().trim();

    var reasons = {
      'insufficient_funds': 'Fondos insuficientes en la tarjeta.',
      'expired_card': 'La tarjeta está caducada.',
      'incorrect_cvc': 'El código de seguridad (CVC) es incorrecto.',
      'invalid_cvc': 'El código de seguridad (CVC) no es válido.',
      'incorrect_number': 'El número de tarjeta es incorrecto.',
      'invalid_expiry_month': 'El mes de caducidad de la tarjeta no es válido.',
      'invalid_expiry_year': 'El año de caducidad de la tarjeta no es válido.',
      'card_declined': 'La tarjeta fue rechazada por el banco.',
      'do_not_honor': 'La tarjeta fue rechazada por el banco.',
      'generic_decline': 'La tarjeta fue rechazada.',
      'lost_card': 'La tarjeta fue rechazada (marcada como perdida).',
      'stolen_card': 'La tarjeta fue rechazada (marcada como robada).',
      'processing_error': 'Error al procesar la tarjeta. Inténtalo de nuevo.',
      'authentication_required': 'El pago requiere autenticación adicional (3D Secure).',
      'try_again_later': 'El banco rechazó el pago temporalmente. Inténtalo más tarde.'
    };

    if (reasons[key]) {
      return reasons[key];
    }

    // Si el código es un genérico interno (invoice_open, subscription_past_due, etc.)
    // no lo mostramos como "motivo": no aporta un motivo real al usuario.
    if (key === '' || key.indexOf('invoice_') === 0 || key.indexOf('subscription_') === 0 || key === 'payment_issue') {
      return '';
    }

    // Código de rechazo desconocido pero presente: mostrar el mensaje de Stripe si lo hay.
    var stripeMessage = this.getBillingValue('paymentIssueMessage', 'PaymentIssueMessage');
    return stripeMessage ? stripeMessage.toString() : '';
  }

  getPaymentPendingAmount(): number {
    var amount = this.getBillingValue('lastInvoiceAmount', 'LastInvoiceAmount');
    if (amount == null) {
      amount = this.getBillingValue('currentPrice', 'CurrentPrice');
    }
    return amount != null ? Number(amount) : 0;
  }

  // Abre la factura pendiente de Stripe (permite pagar y/o cambiar de tarjeta).
  // Si no hay URL de factura, caemos al flujo de actualizar tarjeta para que Stripe reintente.
  payPendingInvoice(): void {
    var url = this.getHostedInvoiceUrl();
    if (url) {
      window.location.href = url;
      return;
    }
    this.updateCardPayment();
  }

  onChangePlanAnual() {
    const isYearly = this.isCurrentYearlyPlan();
    const dialogComponent = isYearly ? MonthlyDowngradeDialogComponent : YearlyUpgradeDialogComponent;
    const targetPeriod = isYearly ? 'month' : 'year';

    const currentFee = this.subscription_actives.filter(c => c.type == 'FEE')[0];
    const targetPlan = currentFee ? this.suscriptions.filter(c => c.id == currentFee.alias)[0] : null;

    const dialogRef = this.dialog.open(dialogComponent, {
      width: '450px',
      maxWidth: '95vw',
      disableClose: false,
      data: {
        planAlias: targetPlan ? targetPlan.id : null,
        period: targetPeriod,
        renewalAmount: targetPlan ? (targetPeriod === 'year' ? targetPlan.amount * 11 : targetPlan.amount) : null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirmed === true) {
        this.shopping_cart.suscription = targetPlan;
        this.shopping_cart.period = targetPeriod;
        this.shopping_cart.services = [];
        this.shopping_cart.prorationDate = result.prorationDate;
        this.pay('plan-change');
      }
    });
  }

  onCancelAccountDialog() {
    const dialogRef = this.dialog.open(CancelAccountDialogComponent, {
      width: '580px',
      maxWidth: '95vw',
      disableClose: false,
      data: {}
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result === true) {
        this.cancelAccount();
      }
    });
  }

  onReactivateSubscription() {
    const subscriptionId = this.getBillingValue('subscriptionId', 'SubscriptionId');
    if (subscriptionId) {
      this.reActivate(subscriptionId);
    }
  }

  getHeaderPeriodText(): string {
    const interval = this.getBillingValue('interval', 'Interval');
    return interval === 'year' ? '/año' : '/mes';
  }

  isCurrentYearlyPlan(): boolean {
    const interval = this.getBillingValue('interval', 'Interval');
    return interval === 'year';
  }

  getChangePlanButtonText(): string {
    return this.isCurrentYearlyPlan() ? '🔄 Cambiar a mensual' : '🔄 Cambiar a anual';
  }

  // La selección de plan ya no es una capa a pantalla completa: es una sección más de esta
  // misma pantalla. Mientras está abierta ocultamos los módulos y el OCR (isSelectingPlan) para
  // que ocupe el sitio de estos y no haya que hacer scroll para verla.
  isSelectingPlan(): boolean {
    return this.status_screen === STATUS_SUBSCRIPTION.SELECT_FEE && !this.isInlinePlanSelectionMode();
  }

  onChangeSelectFee() {
    this.dialog.closeAll();

    this.status_screen = this.status_screen === STATUS_SUBSCRIPTION.SELECT_FEE
      ? STATUS_SUBSCRIPTION.SELECT_SERVICE
      : STATUS_SUBSCRIPTION.SELECT_FEE;
  }

  isCurrentFee(item) {
    return (this.subscription_actives
      && this.subscription_actives.length > 0
      && this.subscription_actives.filter(c => c.alias == item.id && c.dateCancel == null).length > 0)
      || (this.isCurrentFree() && item.id == 'SUBSCRIPTION_FREE');
  }

  openFirstSteps(isFirstTime = false) {
    this.dialog.open(FirstStepsDialogComponent, {
      data: { isFirstTime },
      height: '85%',
      width: '35%',
      panelClass: 'panel-class-first-steps-dialog-component',
      id: 'identifier-first-steps-dialog-component',
      autoFocus: false,
      position: { left: '12%' }
    });
  }


  //SUMMARY PANEL
  getOcrTotal(): number {
    if (!this.shopping_cart || !this.shopping_cart.quantity || this.shopping_cart.quantity <= 0) {
      return 0;
    }

    // Mismo precio que en el texto de la página OCR (0.15 €/página)
    return this.shopping_cart.quantity * 0.15;
  }

  getBillingText(): string {
    if (!this.shopping_cart || !this.shopping_cart.period) {
      return 'mensualmente';
    }

    return this.shopping_cart.period === 'year' ? 'anualmente' : 'mensualmente';
  }

  getSubscriptionAmount(): number {
    if (!this.shopping_cart || !this.shopping_cart.suscription) {
      return 0;
    }

    const monthlyAmount = this.shopping_cart.suscription.amount;

    if (this.shopping_cart.period === 'year') {
      return monthlyAmount * 11;
    }

    return monthlyAmount;
  }

  getTotalWithoutCoupon(): number {
    let total = 0;

    // Plan principal
    if (this.shopping_cart && this.shopping_cart.suscription) {
      total += this.getSubscriptionAmount();
    }

    // Servicios adicionales
    if (this.shopping_cart && this.shopping_cart.services && this.shopping_cart.services.length > 0) {
      for (let i = 0; i < this.shopping_cart.services.length; i++) {
        const service = this.shopping_cart.services[i];
        if (service && service.amount) {
          total += service.amount;
        }
      }
    }

    // OCR
    total += this.getOcrTotal();

    return total;
  }

  getTotal(): number {
    let total = this.getTotalWithoutCoupon();
    const discount = this.getCouponAmountDiscount();

    total = total - discount;
    if (total < 0) {
      total = 0;
    }

    return total;
  }

  //cupon 
  showCouponInput: boolean = false;
  couponCode: string = '';

  onOpenActiveCoupon(): void {
    const dialogRef = this.dialog.open(AddCouponDialogComponent, {
      width: '460px',
      maxWidth: '95vw',
      autoFocus: false,
      data: {
        couponCode: this.couponCode
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result || !result.success) {
        return;
      }

      // Mostrar mensaje de éxito
      const couponData = result.result;
      let message = '✅ Cupón aplicado correctamente';
      
      if (couponData && couponData.percentOff) {
        message = `✅ Cupón aplicado (${couponData.percentOff}% de descuento)`;
      } else if (couponData && couponData.amountOff) {
        message = `✅ Cupón aplicado (${couponData.amountOff}€ de descuento)`;
      }
      
      this.displayMessage(message);
      
      // Recargar la información de facturación para mostrar el descuento
      this.getBillingOverview();
    });
  }

  private tryApplyCouponForActiveSelection(): Promise<void> {
    return new Promise((resolve) => {
      if (this.isCurrentFree()) {
        resolve();
        return;
      }

      if (!this.couponCode || this.couponCode.trim() === '') {
        resolve();
        return;
      }

      if (!this.shopping_cart || !this.shopping_cart.suscription) {
        resolve();
        return;
      }

      const totalBefore = this.getTotalWithoutCoupon();
      if (totalBefore <= 0) {
        resolve();
        return;
      }

      const codeRaw = this.couponCode.trim();
      const codeUpper = codeRaw.toUpperCase();

      this.checkoutService.getCoupon({ couponCode: codeUpper, period: this.shopping_cart.period, subscriptionId: this.shopping_cart.suscription.id }).then(result => {
        if (!this.shopping_cart) {
          this.shopping_cart = {};
        }

        const percentOff = result.percentOff;
        const amountOff = result.amountOff;

        if (percentOff === -1 || percentOff == null || !percentOff) {
          this.shopping_cart.couponCode = '';
          this.shopping_cart.couponApplied = false;
          this.shopping_cart.couponAmountOff = 0;
          this.shopping_cart.couponPercent = 0;
          this.updateTotalAmount();
          resolve();
          return;
        }

        if (percentOff === 0) {
          this.shopping_cart.internalCouponCode = codeUpper;
          this.shopping_cart.couponCode = this.couponCode;
          this.showCouponInput = false;
          this.couponCode = '';
          this.updateTotalAmount();
          resolve();
          return;
        }

        if (percentOff > 0) {
          const discountPercent = percentOff;

          this.shopping_cart.couponCode = this.couponCode;
          this.shopping_cart.couponApplied = true;
          this.shopping_cart.couponAmountOff = amountOff;
          this.shopping_cart.couponPercent = discountPercent;

          this.showCouponInput = false;
          this.couponCode = '';
        }

        resolve();
      }).catch(error => {
        resolve();
      });
    });
  }

  toggleCouponInput(): void {
    this.showCouponInput = !this.showCouponInput;
  }

  updateCoupon(): void {
    if (this.shopping_cart.couponCode != null) this.couponCode = this.shopping_cart.couponCode;

    if (!this.couponCode || this.couponCode.trim() === '') {
      // this.displayMessage('Introduce un cupón válido');
      return;
    }

    const totalBefore = this.getTotalWithoutCoupon();
    if (totalBefore <= 0) {
      return;
    }

    const codeRaw = this.couponCode.trim();
    const codeUpper = codeRaw.toUpperCase();

    this.checkoutService.getCoupon({ couponCode: codeUpper, period: this.shopping_cart.period, subscriptionId: this.shopping_cart.suscription.id }).then(result => {
      if (!this.shopping_cart) {
        this.shopping_cart = {};
      }

      const percentOff = result.percentOff;
      const amountOff = result.amountOff;

      if (percentOff === -1 || percentOff == null || !percentOff) {
        this.shopping_cart.couponCode = '';
        this.shopping_cart.couponApplied = false;
        this.shopping_cart.couponAmountOff = 0;  // 👈 guardamos % aquí
        this.shopping_cart.couponPercent = 0;  // 👈 guardamos % aquí
        this.updateTotalAmount();
        return;
      }

      if (percentOff === 0) {
        // Cupón interno (no se muestra descuento visual)
        this.shopping_cart.internalCouponCode = codeUpper;
        this.shopping_cart.couponCode = this.couponCode;

        this.showCouponInput = false;
        this.couponCode = '';
        this.updateTotalAmount();
        return;
      }

      if (percentOff > 0) {
        const discountPercent = percentOff;

        this.shopping_cart.couponCode = this.couponCode;
        this.shopping_cart.couponApplied = true;
        this.shopping_cart.couponAmountOff = amountOff;  // 👈 guardamos % aquí
        this.shopping_cart.couponPercent = discountPercent;  // 👈 guardamos % aquí

        this.showCouponInput = false;
        this.couponCode = '';
        this.updateTotalAmount();
      }

    }).catch(error => {
      this.displayMessage('No se ha podido validar el cupón. Inténtelo de nuevo más tarde.');
    });
  }

  applyCoupon(): void {
    if (!this.couponCode || this.couponCode.trim() === '') {
      this.displayMessage('Introduce un cupón válido');
      return;
    }

    const totalBefore = this.getTotalWithoutCoupon();
    if (totalBefore <= 0) {
      this.displayMessage('No hay importe sobre el que aplicar el cupón');
      return;
    }

    const codeRaw = this.couponCode.trim();
    const codeUpper = codeRaw.toUpperCase();

    this.checkoutService.getCoupon({ couponCode: codeUpper, period: this.shopping_cart.period, subscriptionId: this.shopping_cart.suscription.id }).then(result => {
      if (!this.shopping_cart) {
        this.shopping_cart = {};
      }

      const percentOff = result.percentOff;
      const amountOff = result.amountOff;

      if (percentOff === -1 || percentOff == null || !percentOff) {
        this.shopping_cart.couponCode = '';
        this.shopping_cart.couponApplied = false;
        this.shopping_cart.couponAmountOff = 0;  // 👈 guardamos % aquí
        this.shopping_cart.couponPercent = 0;  // 👈 guardamos % aquí
        this.updateTotalAmount();
        this.displayMessage('El cupón no es válido');
        return;
      }

      if (percentOff === 0) {
        // Cupón interno (no se muestra descuento visual)
        this.shopping_cart.internalCouponCode = codeUpper;
        this.shopping_cart.couponCode = this.couponCode;

        this.showCouponInput = false;
        this.couponCode = '';
        this.updateTotalAmount();

        this.displayMessage('Cupón aplicado');
        return;
      }

      if (percentOff > 0) {
        const discountPercent = percentOff;

        this.shopping_cart.couponCode = this.couponCode;
        this.shopping_cart.couponApplied = true;
        this.shopping_cart.couponAmountOff = amountOff;  // 👈 guardamos % aquí
        this.shopping_cart.couponPercent = discountPercent;  // 👈 guardamos % aquí

        this.showCouponInput = false;
        this.couponCode = '';
        this.updateTotalAmount();

        this.displayMessage('Cupón aplicado (' + discountPercent + '% de descuento)');
      }

    }).catch(error => {
      this.displayMessage('No se ha podido validar el cupón. Inténtelo de nuevo más tarde.');
    });
  }

  getCardPrice(item: any): number {
    if (!item || !item.amount) {
      return 0;
    }

    const monthlyAmount = item.amount;

    if (this.shopping_cart && this.shopping_cart.period === 'year') {
      // MISMA REGLA que en el resumen:
      // 12 meses cobrando 11 (1 mes gratis)
      return monthlyAmount * 11;

      // Si quisieras 12 meses sin regalar uno:
      // return monthlyAmount * 12;
    }

    // Periodo mensual -> mostramos precio mensual
    return monthlyAmount;
  }


  removeCoupon(): void {
    if (!this.shopping_cart) {
      return;
    }

    this.shopping_cart.couponCode = null;
    this.shopping_cart.couponApplied = false;
    this.shopping_cart.couponPercent = 0;
    this.couponCode = '';
  }

  getCouponAmountDiscount(): number {
    if (!this.shopping_cart ||
      !this.shopping_cart.couponApplied ||
      !this.shopping_cart.couponPercent ||
      this.shopping_cart.couponPercent <= 0) {
      return 0;
    }

    if (this.shopping_cart.couponAmountOff) {
      return this.shopping_cart.couponAmountOff;
    }

    const totalBefore = this.getTotalWithoutCoupon();

    return totalBefore * this.shopping_cart.couponPercent / 100;
  }

  public trackByIndex(i: number) { return i; }

}

